
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 129.8 121.7"}},[_c('path',{attrs:{"d":"M64.9 0L0 64.9h16.2v56.8h32.5V73h32.4v48.7h32.5V64.9h16.2z"}})])
      }
    
      }
    